// extracted by mini-css-extract-plugin
export default {"main":"MainContent-module__main__zLHnk","modern":"MainContent-module__modern__LO20m"};